import React from 'react';
import { MBAnimation, MBAnimationProps } from './base';

export function MBAnimationFadeIn(props: MBAnimationProps) {
  return <MBAnimation opacity={{ from: 0, to: 1 }} {...props} />;
}

export function MBAnimationFadeOut(props: MBAnimationProps) {
  return <MBAnimation opacity={{ from: 1, to: 0 }} {...props} />;
}
